<template>
  <div class="pageView">
    <div v-show="headerAndFooter">
      <NavBar
          :title="''"
          :placeholder="true"
          safe-area-inset-top
      >
        <template #right>
          <div class="video_btn-call-end" @click="doHungUp">通話終了</div>
        </template>
        <template #left>
          <img
              src="../../assets/img/video/video_icon-camera.png"
              style="width: 30px"
              alt=""
              @click="changeCamera"
          />
        </template>
      </NavBar>
    </div>
    <main class="mainDiv" @click="clickScreen">
      <!-- 左上悬浮 -->
      <div class="change-box" >
        <div :style="changeViewShow?'display:block;':'display:none;'" class="main-btn" @click.stop="changeFrame">画面表示切り替え</div>
        <div :style="changeViewShow?'display:none;':'display:block;'"
             :class = "viewType=='grid'?'':'select'"
             class="change-btn change-btn_speaker" @click.stop="changeView('speaker')">スピーカービュー</div>
        <div :style="changeViewShow?'display:none;':'display:block;'"
             :class = "viewType=='grid'?'select':''"
             class="change-btn change-btn_grid" @click.stop="changeView('grid')">ギャラリービュー</div>
      </div>
      <!-- 右上悬浮 -->
      <div class="multi-box" v-if="multiCallUser" @click.stop="noticeJoinMultiCall">
        入室許可
      </div>
      <!-- 语音转文字 -->
      <div class="roomCoversation-audioText"  style="z-index: 997"
           v-show="audioText.length>0 && this.tool_value.checkedSubtitle"
           @scroll="handleScroll" ref="audioTextRef">
        <div>
          <p v-for="item in audioText" :key="item"> {{item}}</p>
        </div>
      </div>
      <!-- 虚拟背景 -->
      <div>
        <canvas ref="myCanvas" id="myCanvas" style="display: none;min-width:100px;"></canvas>
        <video id="soucevideo" autoplay webkit-playsinline playsinline muted="muted"
               style="display: none;width: 100%;height: 100%;object-fit: cover; min-width: 100px"/>
      </div>
      <!--video区域-->
      <div class="video-box">
        <div @click.stop="goPage(-1)" :style="arrowDivStyle('left')">
          <img src="../../assets/img/room/arrowWhite.svg" :style="arrowImgStyle('left')" >
        </div>
        <div :style="solidBoxStyleSpeaker()">
          <div class='hide-scrollbar' :style="speakDiv1()" ref="speakDiv1Ref"
               @mousedown="mouseDownHandler"
               @mousemove="mouseMoveHandler"
               @mouseup="mouseUpHandler">
            <!-- 自己的视频 speak-->
            <div v-for="(stream, index) in feedStreams" :key="stream[0].user_id" style="display:none">
              <audio hidden :id="'remoteAudio'+stream[0].user_id"  autoplay playsinline></audio>
            </div>
            <div :style="speakVideoDiv1('local')" :class="localStream.showLocalVideo ? 'backgroundColorBlack':'backgroundColorWhite'">
              <video v-show="localStream.showLocalVideo" id="localvideo1"  src="" autoplay playsinline @dblclick="makeFullscreen"
                :style="{height: '100%',width:'100%',objectFit:'contain'
                ,transform: facingMode=='user' ?'scaleX(-1)':''}" muted="muted"></video>
              <div v-show="!localStream.showLocalVideo" :style="remoteNoVideoStyle()" class="no-video" >
<!--                 <p>{{ myusername }}</p>-->
              </div>
              <span class="nameSpan">{{ myusername }}</span>
            </div>
            <!-- 其他人的视频 -->
            <div v-for="(stream, index) in feedStreams" :key="stream[0].user_id" :style="speakVideoDiv1(stream[0].user_id)"
                 :class="stream[0].showVideo ? 'backgroundColorBlack':'backgroundColorWhite'">
              <video v-show="stream[0].showVideo " :id="'remoteVideo1'+stream[0].user_id" src="" autoplay playsinline @dblclick="makeFullscreen"
                     :style="{height: '100%',width: '100%',objectFit:'contain'}" muted="muted"></video>
              <div v-show="!stream[0].showVideo" :style="remoteNoVideoStyle()" class="no-video" >
<!--                <p >画面共有</p>-->
              </div>
              <span class="nameSpan">{{ stream[0].display }}</span>
              <span class="bitSpan">{{ stream[0]?.bit }}</span>
              <div class="status-indicators">
                <div :class="['status-icon', stream[0].showVideo ? 'active' : 'inactive']">
                  <img :src="require('../../assets/img/video/video_menu_video_on.svg')" v-if="stream[0].showVideo">
                  <img :src="require('../../assets/img/video/video_menu_video_off.svg')" v-else>
                </div>
                <div :class="['status-icon', stream[0].showAudio ? 'active' : 'inactive']">
                  <img :src="require('../../assets/img/video/video_menu_mike_on.svg')" v-if="stream[0].showAudio">
                  <img :src="require('../../assets/img/video/video_menu_mike_off.svg')" v-else>
                </div>
              </div>
            </div>
          </div>
          <div :style="speakDiv2()">
            <!-- 自己的视频 -->
            <div :style="speakVideoDiv2('local')" :class="localStream.showLocalVideo ? 'backgroundColorBlack':'backgroundColorWhite'">
              <video v-show="localStream.showLocalVideo" id="localvideo2"  src="" autoplay playsinline @dblclick="makeFullscreen"
                     :style="{ height: '100%',width: '100%',objectFit:'contain'
                     ,transform: facingMode=='user' ?'scaleX(-1)':''}" muted="muted"></video>
              <div v-show="!localStream.showLocalVideo" :style="localNoVideoStyle()" class="no-video" >
                <!--              <p>{{ myusername }}</p>-->
              </div>
              <span class="nameSpan bigNameSpan">{{ myusername }}</span>
            </div>
            <!-- 其他人的视频 speak-->
            <div :style="speakVideoDiv2(stream[0].user_id)" v-for="(stream, index) in feedStreams" :key="stream[0].user_id"
                 :class="stream[0].showVideo && shareScreenStyle(stream)? 'backgroundColorBlack':'backgroundColorWhite'">
              <video v-show="stream[0].showVideo && shareScreenStyle(stream)" :id="'remoteVideo2'+stream[0].user_id" src="" autoplay playsinline @dblclick="makeFullscreen"
                     :style="{ height: '100%',width: '100%',objectFit:'contain'}" muted="muted"></video>
              <div v-show="!stream[0].showVideo || !shareScreenStyle(stream)" :style="localNoVideoStyle()" class="no-video" >
                <p v-show="stream[0].showVideo && !shareScreenStyle(stream)">画面共有</p>
              </div>
              <span class="nameSpan bigNameSpan">{{ stream[0].display }}</span>
              <span class="bitSpan">{{ stream[0]?.bit }}</span>
              <div class="status-indicators">
                <div :class="['status-icon', stream[0].showVideo ? 'active' : 'inactive']">
                  <img :src="require('../../assets/img/video/video_menu_video_on.svg')" v-if="stream[0].showVideo">
                  <img :src="require('../../assets/img/video/video_menu_video_off.svg')" v-else>
                </div>
                <div :class="['status-icon', stream[0].showAudio ? 'active' : 'inactive']">
                  <img :src="require('../../assets/img/video/video_menu_mike_on.svg')" v-if="stream[0].showAudio">
                  <img :src="require('../../assets/img/video/video_menu_mike_off.svg')" v-else>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :style="solidBoxStyleGrid()" >
          <div :style="gridDiv('local')" :class="localStream.showLocalVideo ? 'backgroundColorBlack':'backgroundColorWhite'">
            <video v-show="localStream.showLocalVideo" id="localvideo3" src="" autoplay playsinline @dblclick="makeFullscreen"
              :style="{ height: '100%',width: '100%',objectFit:'contain'
                ,transform: facingMode=='user' ?'scaleX(-1)':''}" muted="muted"></video>
            <div v-show="!localStream.showLocalVideo" :style="gridNoVideo()" class="no-video" >
              <!--              <p>{{ myusername }}</p>-->
            </div>
            <span class="nameSpan bigNameSpan">{{ myusername }}</span>
          </div>
          <div v-for="(stream, index) in feedStreams" :key="stream[0].user_id" :style="gridDiv('remote',index)"
               :class="stream[0].showVideo && shareScreenStyle(stream) ? 'backgroundColorBlack':'backgroundColorWhite'">
            <video v-show="stream[0].showVideo && shareScreenStyle(stream) " :id="'remoteVideo3'+stream[0].user_id" src="" autoplay playsinline @dblclick="makeFullscreen"
                   :style="{ height: '100%',width: '100%',objectFit:'contain'}" muted="muted"></video>
            <div v-show="!stream[0].showVideo || !shareScreenStyle(stream) " :style="gridNoVideo()" class="no-video" >
              <p v-show="stream[0].showVideo && !shareScreenStyle(stream)">画面共有</p>
            </div>
            <span class="nameSpan bigNameSpan">{{ stream[0].display }}</span>
            <span class="bitSpan">{{ stream[0]?.bit }}</span>
            <div class="status-indicators" :style="stream[0].display== '画面共有'?'display:none':'' ">
              <div :class="['status-icon', stream[0].showVideo ? 'active' : 'inactive']">
                <img :src="require('../../assets/img/video/video_menu_video_on.svg')" v-if="stream[0].showVideo">
                <img :src="require('../../assets/img/video/video_menu_video_off.svg')" v-else>
              </div>
              <div :class="['status-icon', stream[0].showAudio ? 'active' : 'inactive']">
                <img :src="require('../../assets/img/video/video_menu_mike_on.svg')" v-if="stream[0].showAudio">
                <img :src="require('../../assets/img/video/video_menu_mike_off.svg')" v-else>
              </div>
            </div>
          </div>
        </div>
        <div  @click.stop="goPage(1)" :style="arrowDivStyle('right')">
          <img src="../../assets/img/room/arrowWhite.svg" :style="arrowImgStyle('right')" >
        </div>
      </div>
    </main>
    <div class="video-setting-box" :class="this.detailShow ? 'open' : ''">
      <div class="video-setting-box_inner">
        <div class="video-setting-top">
          <p class="video-setting-title">詳細設定</p>
          <a class="video-setting-close" @click="saveDetail">完了</a>
        </div>
        <div class="video_switching-list" v-show="agentType=='PC'">
          <div class="video_switching-item video_sw_item">
            <p class="video_switching-name">音声字幕</p>
            <div class="video_switching-box" :class="tool_value.checkedSubtitle?'':'checked'" @click="changeCheckBoxValue('checkedSubtitle')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
        </div>
        <div class="video_switching-list">
          <div class="video_switching-item video_sw_item">
            <p class="video_switching-name">バーチャル背景</p>
            <div class="video_switching-box" :class="tool_value.checkedBackground?'':'checked'" @click="changeCheckBoxValue('checkedBackground')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
        </div>
        <div class="video_switching-list">
          <div class="video_switching-item video_sw_item">
            <p class="video_switching-name">背景をぼかす</p>
            <div class="video_switching-box" :class="tool_value.checkedBlurBackground?'':'checked'" @click="changeCheckBoxValue('checkedBlurBackground')">
              <input class="toggle_input" type='checkbox' />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footDiv"  v-show="headerAndFooter" :style="agentType=='PC'?'grid-template-columns:repeat(5,1fr)':'grid-template-columns:repeat(4,1fr)'">
        <div class="footDiv-item">
          <img
              :src="[this.localStream.showLocalAudio ? require('../../assets/img/video/video_menu_mike_on.svg')
              : require('../../assets/img/video/video_menu_mike_off.svg')]"
              alt="マイク"
              @click="changeVideoOrAudio('mike')"
          />
          <p class="iconSpan">マイク</p>
        </div>
        <div class="footDiv-item" v-show="!footerItem">
          <img
              :src="[this.localStream.showLocalVideo ? require('../../assets/img/video/video_menu_video_on.svg')
              : require('../../assets/img/video/video_menu_video_off.svg')]"
              alt="ビデオ"
              @click="changeVideoOrAudio('video')"
          />
          <p class="iconSpan">ビデオ</p>
        </div>
<!--        <div class="footDiv-item" v-show="!footerItem">-->
<!--          <img-->
<!--              :src="require('../../assets/img/video/video_menu_cc.svg')"-->
<!--          />-->
<!--          <p class="iconSpan">字幕表示</p>-->
<!--        </div>-->
        <div class="footDiv-item" v-show="!footerItem">
          <img
              :src="require('../../assets/img/video/video_menu_user.svg')"
              @click="showUsers"
          />
          <p class="iconSpan">参加者</p>
        </div>
        <div class="footDiv-item" v-show="!footerItem && agentType=='PC'">
          <img
              :src="require('../../assets/img/video/video_menu_video_share.svg')"
              @click="cilckShareScreen"
          />
          <p class="iconSpan">画面共有</p>
        </div>
        <div class="footDiv-item" v-show="!footerItem">
          <img
              :src="require('../../assets/img/video/video_menu_setting.svg')"
              @click="openDetail"
          />
          <p class="iconSpan">設定</p>
        </div>
      </div>
      <!--      userlist-->
    <div :style="{ top: headerAndFooter ? '50px' : '0' }" class="sidebar-users-box open" v-show="showUserList">
      <div class="sidebar-users-inner">
        <button class="sidebar-close-btn" @click.stop="showUsers()">∨</button>
          <li class="sidebar-users-item" >
            <div class="sidebar-users-logo">
              {{ myusername.substring(0,1) }}
            </div>
            {{ myusername }}
          </li>
          <li class="sidebar-users-item" v-for="(item, i) in feedStreams" :key="item[0].user_id"
              v-show="item[0].user_id.substring(0,13) !== 'screen-share_' ">
            <div class="sidebar-users-logo">
              {{ item[0].display.substring(0,1) }}
            </div>
            {{ item[0].display }}
          </li>
      </div>
    </div>

  </div>

</template>

<script>
import Janus from "@/assets/js/janus";
import {Dialog, NavBar, Toast} from "vant";
import { RefreshUserInfo } from "@/services/login";
import {RoomYoteiCheck, SaveRoomLog} from "@/services/room";
import {SelfieSegmentation} from "@mediapipe/selfie_segmentation";
// import 'context-filter-polyfill';
import * as StackBlur from 'stackblur-canvas';
import {doSend} from "@/utils/websocket";
import {GetDoctorDetail} from "@/services/team";
import {pushMessage} from "@/services/pushmessage";
import {GetPatientDetails} from "@/services/patient";


export default {
  name: "roomConversation",
  data() {
    return {
      janus_server: process.env.VUE_APP_JANUS_SERVER,
      opaqueId: "videoroomtest-" + Janus.randomString(12),
      //roomid,从url获取
      roomid: 1234,
      myusername: "",
      myaccountid: "",
      myid: "",
      maxPublishersNum: 100,
      sfutest: null,
      doSimulcast: false, //联播，后续再用
      mypvtid: null,
      // 所有远程已订阅的媒体流信息
      feeds: [],
      // 自己的steam
      localTracks:{},
      // 不包括自己，所有用户的stream信息
      feedStreams: [],
      //本地音视频流
      localStream: {
        //是否显示本地视频
        showLocalVideo: true,
        // 音视频stream
        showLocalAudio :true,
      },
      // 开启共享屏幕备份视频开启状态
      backShowLocalVideo: true,
      // 底部功能栏显示
      footerItem: false,
      // 头部底部栏显示
      headerAndFooter: true,
      changeViewShow:true,
      // 参加者リスト
      showUserList: false,
      userList: true,
      //保存roomlog用
      room_id: "",
      // 屏幕共有用视频流
      shareScreenStream:null,
      checkedShareScreen:false,
      sendStream : null,
      lastStream : null,
      sendAudioStream :null,
      firstSendVideoStream :true,
      firstSendAudioStream :true,
      // 显示视频样式
      viewType :'grid',
      // 设置的视频的created高度宽度
      item_height : 150,
      item_width : 150,
      // 正在说话样式
      speaker_height :150,
      speaker_width :150,
      // 显示的列数
      columnsCount:1,
      // 正在说话的人
      speaking_user:null,
      // 翻页变量
      page_user:8,
      page_num:1,
      page_total:1,
      // 本地视频流
      stream: null,
      facingMode:'user',
      // speaker模式pc滚动用
      pageX: 0,
      startScrollLeft: 0,
      isMouseDown: false,
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent),
      // 底部工具栏拉起状态
      detailShow: false,
      // 底部功能栏目项目
      tool_value:{
        // 音声字幕
        checkedSubtitle: false,
        // 虚拟背景
        checkedBackground: false,
        // 虚化背景
        checkedBlurBackground: false,
      },
      // 底部功能栏目项目备份
      back_tool_value:{
        checkedSubtitle: false,
        checkedBackground :false,
        checkedBlurBackground: false,
      },
      // 共享屏幕的人
      shareScreenClickAble:true,
      screenShareJanus:null,
      screenShareHandle: null,
      screenMyid:"",
      screenMypvtid:"",
      shareScreenUser:null,
      // 设备类型
      agentType:"PC",
      // 语音转文字用
      recognition:null,
      audioText:[],
      // 虚拟背景用
      context:null,
      image: null,
      rafId: null,
      // 接受消息唯一
      receiveMsgUid:null,
      // 速度慢时的弹窗
      dialogSpeed :null,
      // 三方通话
      multiCallUser : null,
      multiCallUserType : null,
      multiCall : false,
      multiCallAdmin : false,
      // 预约会议用
      yotei_id:null,
      ticket:null,
      yoteiInterval:null,
      yoteiTimeout:null,
      yoteiDialogHasShow:false,
      // 麦克风权限
      audioPermission:true,
      videoPermission:true,
    };
  },
  components: {
    NavBar,
  },
  mounted() {
    // window.appC = this;
    this.$store.state.routeViewComponent = this;

    this.agentType = this.checkUrl();
    this.roomid = parseInt(this.$route.query.id);
    this.room_id = this.$route.query.room_id;
    this.localStream.showLocalAudio = eval(this.$route.query.mikeOpen);
    this.localStream.showLocalVideo = eval(this.$route.query.cameraOpen);
    // 本页面的multiCallUser和single不用 指的是最开始通话然后进入等待的B
    this.multiCallUser = this.$route.query.multiCallWaitUser;
    this.multiCallUserType = this.$route.query.multiCallWaitUserType;
    this.multiCall = this.$route.query.multiCall == 'true';
    this.multiCallAdmin = this.multiCallUser? true : false;
    // 预约会议用
    this.yotei_id = this.$route.query.yotei_id;
    this.ticket = this.$route.query.ticket;

    setTimeout(() => {
      this.JanusInit();
      this.calcVideoSize();
      window.addEventListener("resize", this.calcVideoSize);
      // 添加预约会议检测
      this.checkYotei();
    }, 100);
    // setInterval(() => {
    //   if(this.sfutest){
    //     console.log(this.roomid);
    //     this.sfutest.send({message: { request: "list" },});
    //   }
    //   // if(this.feedStreams.length>0){
    //   //   this.feedStreams[0].forEach((item)=>{
    //   //     if(item.type == 'audio'){
    //   //       console.log(item);
    //   //     }
    //   //   });
    //   // }
    //   console.log(this.feedStreams);
    // },2000);

  },
  beforeUnmount() {
    this.doHungUp();
    this.$store.state.routeViewComponent = null;
    window.removeEventListener("resize", this.calcVideoSize);
  },
  methods: {
    // test(message){
    //   // this.sfutest.send({message: { request: message },});
    // },
    test2(){
      // 删除room方法
      // let room_list = [];
      // let room_list = [];
      // room_list.forEach((item)=>{
      //   var destroy = {
      //     request: "destroy",
      //     room: item,
      //   };
      //   this.sfutest.send({ message: destroy });
      // })
    },
    doMethods(params){
      if(params['action_page'] == 'roomConversation'){
        if(params['method'] == 'offLineCall'){
          this.sendMultiCallMsg();
        }else if(params['method'] == 'multiCallEnd'){
          if(this.multiCall){
            this.doHungUp();
          }
        }
      }
    },
    checkYotei(){
      // 需要显示dialog
      this.yoteiDialogHasShow = false;
      if(this.yoteiInterval){
        clearInterval(this.yoteiInterval)
      }
      this.doYoteiAction();
      // 10分钟检测一次
      this.yoteiInterval = setInterval(async ()=>{
        this.doYoteiAction();
      },10*60*1000)
      // },10*60*1000)
    },
    async doYoteiAction(){
      if(this.yoteiTimeout){
        clearTimeout(this.yoteiTimeout);
      }
      let res = await RoomYoteiCheck({room_id:this.room_id,yotei_id:this.yotei_id,ticket:this.ticket});
      if(res.data.code >= 0){
        const { yotei_list, room_permission } = res.data.data;
        // 无预约会议且无权限时，直接退出
        if (yotei_list.length === 0) {
          if(!room_permission){
            this.doHungUp();
          }
          return;
        }
        const meeting = yotei_list[0];
        // 10分钟阈值
        const timeThreshold = 600;
        if (meeting.meeting_status === 'in_progress') {
          // 会议进行中
          if(!meeting.yotei_permission){
            // 没有权限
            this.doHungUp();
            return;
          }
          const seconds = meeting.seconds_until_end;
          if (seconds <= timeThreshold) {
            const minute = Math.ceil(seconds / 60);
            console.log(`提示还有${seconds}秒`);
            if (!this.yoteiDialogHasShow) {
              Dialog.alert({
                message: `会議(${meeting.yotei_name})は${minute}分後に終了します`,
                theme: 'round-button',
                confirmButtonText: '確認',
              });
              this.yoteiDialogHasShow = true;
            }
            this.yoteiTimeout = setTimeout(() => {
              this.yoteiDialogHasShow = false;
              this.checkYotei();
            }, seconds * 1000);
          } else {
            const timeUntil10Minutes = seconds - timeThreshold;
            console.log(`${timeUntil10Minutes}秒后提示还有10分钟`);
            this.yoteiTimeout = setTimeout(() => {
              if (!this.yoteiDialogHasShow) {
                Dialog.alert({
                  message: `会議(${meeting.yotei_name})は10分後に終了します。`,
                  theme: 'round-button',
                  confirmButtonText: '確認',
                });
                this.yoteiDialogHasShow = true;
              }
            }, timeUntil10Minutes * 1000);
            // 后续还会执行一次这个方法 所以不用调用结束
          }
        } else if (meeting.meeting_status === 'not_started') {
          const seconds = meeting.seconds_until_start;
          if (seconds <= timeThreshold) {
            const minute = Math.ceil(seconds / 60);
            console.log(`提示还有${seconds}秒`);
            if (!this.yoteiDialogHasShow) {
              Dialog.alert({
                message: `会議(${meeting.yotei_name})は${minute}分後に開始します`,
                theme: 'round-button',
                confirmButtonText: '確認',
              });
              this.yoteiDialogHasShow = true;
            }
            this.yoteiTimeout = setTimeout(() => {
              this.yoteiDialogHasShow = false;
              this.doYoteiAction();
            }, seconds * 1000);
          } else {
            const timeUntil10Minutes = seconds - timeThreshold;
            console.log(`${timeUntil10Minutes}秒后提示还有10分钟`);
            this.yoteiTimeout = setTimeout(() => {
              if (!this.yoteiDialogHasShow) {
                Dialog.alert({
                  message: `会議(${meeting.yotei_name})は10分後に開始します。`,
                  theme: 'round-button',
                  confirmButtonText: '確認',
                });
                this.yoteiDialogHasShow = true;
              }
            }, timeUntil10Minutes * 1000);
          }
        }
      }
    },
    sendMultiCallMsg(){
      // 发送唤醒服务
      let service_msg = { to_service: [this.multiCallUser + "_service"] };
      doSend(JSON.stringify(service_msg));
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      let multiCallMsg = {send_type:"multiCall",method: "multiCall"
        ,type:"apply",to_users:[this.multiCallUser],status:'wait',roomId:this.roomid
        ,call_user : userInfo.login_account_id ,call_user_name : userInfo.name};
      doSend(JSON.stringify(multiCallMsg));
    },
    async noticeJoinMultiCall(){
      let res;
      if(this.multiCallUserType == '4'){
        // 医生
        res = await GetDoctorDetail(this.multiCallUser);
      }else if(this.multiCallUserType == '5'){
        // 患者
        res = await GetPatientDetails(this.multiCallUser);
      }else{
        return;
      }
      let user = res.data.data.detail;
      let type;
      if(user.online_status == 'online'){
        // 在线则发送消息给对方 等待返回消息
        type = 'online';
      }else{
        // 离线
        if (user.push_status != "can") {
          type = 'busy';
        }else{
          type = 'offline';
        }
      }
      if(type == 'busy'){
        // 离线切占用中无法push
        Dialog.alert({
          message: '現在通話中\n後ほどお掛け直しください',
          theme: 'round-button',
          confirmButtonText: 'キャンセル',
        });
        return;
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(type == 'online'){
        // 在线的话直接发送消息 通知等待用户进入room
        this.sendMultiCallMsg();
      }else if(type == 'offline'){
        console.log("离线");
        // 离线拨打
        pushMessage({
          to_user: this.multiCallUser,
          push_user: userInfo.name,
          call_type: 6,
          type: this.multiCallUserType,
        });
        // 发送唤醒服务
        let service_msg = { to_service: [this.multiCallUser + "_service"] };
        doSend(JSON.stringify(service_msg));
      }
    },
    handleScroll(event) {
      event.stopPropagation();
    },
    checkUrl(){
      let userAgent = navigator.userAgent;
      if(/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
        return "Tablet"; // 判断是否为平板设备
      }
      else if(/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/i.test(userAgent)) {
        return "Mobile"; // 判断是否为手机设备
      }
      return "PC"; // 其他情况判断为电脑设备
    },
    shareScreenStyle(stream){
      // true 就是黑底显示视频
      if(stream[0].display == '画面共有'){
        if(stream[0].user_id != ('screen-share_' + this.myaccountid)){
          return true;
        }else{
          return false;
        }
      }else{
        return true;
      }
    },
    receiveRoomMsg(receiveRoomMsg){
      console.log(receiveRoomMsg);
      if(receiveRoomMsg['method'] == "shareScreen"){
        // this.subscribeScreenShare(receiveRoomMsg['userId'], receiveRoomMsg['display']);
      }

    },
    setLocalVideo(){
      if(this.viewType =='grid'){
        Janus.attachMediaStream(JQuery("#localvideo3").get(0), this.sendStream);
        Janus.attachMediaStream(JQuery("#localvideo1").get(0), null);
        Janus.attachMediaStream(JQuery("#localvideo2").get(0), null);
      }else{
        // 处于屏幕共享或其他人正在说话
        Janus.attachMediaStream(JQuery("#localvideo1").get(0), this.sendStream);
        Janus.attachMediaStream(JQuery("#localvideo2").get(0), this.sendStream);
        Janus.attachMediaStream(JQuery("#localvideo3").get(0), null);
      }
    },
    setRemoteVideo(rfid){
      this.feedStreams.forEach((item) => {
        if (!rfid  || item[0].user_id == rfid) {
          if(this.viewType =='grid') {
            Janus.attachMediaStream(JQuery("#remoteVideo3" + item[0].user_id).get(0), item[0].videoStream);
            Janus.attachMediaStream(JQuery("#remoteVideo1" + item[0].user_id).get(0), null);
            Janus.attachMediaStream(JQuery("#remoteVideo2" + item[0].user_id).get(0), null);
          } else {
            Janus.attachMediaStream(JQuery("#remoteVideo3" + item[0].user_id).get(0), null);
            Janus.attachMediaStream(JQuery("#remoteVideo1" + item[0].user_id).get(0), item[0].videoStream);
            Janus.attachMediaStream(JQuery("#remoteVideo2" + item[0].user_id).get(0), item[0].videoStream);
          }
        }
      });
    },
    makeFullscreen(event){
      const element = event.target;
      if (document.fullscreenElement) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      }
    },
    openDetail(){
      this.detailShow = true;
      this.back_tool_value = Object.assign({}, this.back_tool_value, this.tool_value);
    },
    async saveDetail() {
      if(this.tool_value.checkedBackground && this.tool_value.checkedBlurBackground){
        Toast("背景のぼかしとバーチャル背景を同時に開けません。");
        return;
      }
      if(this.tool_value.checkedBackground){
        let userRet = await RefreshUserInfo();
        let userInfo = userRet.data.data.user;
        if(!userInfo.backgroundpath){
          Toast.fail("背景画像をアップロードしてください");
          return
        }
      }
      this.detailShow = false;
      // 音声を文字化する
      if (this.tool_value.checkedSubtitle != this.back_tool_value.checkedSubtitle) {
        if (this.tool_value.checkedSubtitle && this.localStream.showLocalAudio) {
          this.startWebSpeech();
        } else {
          this.stopWebSpeech();
        }
      }
      // 如果摄像头没开启 则只需要保存
      if(this.localStream.showLocalVideo){
        if (this.tool_value.checkedBackground != this.back_tool_value.checkedBackground
            || this.tool_value.checkedBlurBackground != this.back_tool_value.checkedBlurBackground) {
          let check = await this.getSendStream();
          if(check){
            this.sfutest.createOffer({tracks: [{
              type: 'video', replace: true, capture: this.sendStream.getVideoTracks()[0]
            }],});
          }
        }
      }
    },
    stopCanvas(){
      // 清理 `canvas` 内容
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      // 清理视频元素的事件监听
      const videoElement = JQuery("#soucevideo").get(0);
      if (videoElement && videoElement.playingListener) {
        videoElement.removeEventListener("playing", videoElement.playingListener);
        videoElement.playingListener = null;
      }

      if(this.context  && this.$refs.myCanvas){
        this.context.clearRect(0, 0,this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      }
      this.context = null;
      this.image = null;
    },
    async createCanvas(stream, type) {
     await this.stopCanvas();

      let user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      this.context = this.$refs.myCanvas.getContext("2d");

      const selfieSegmentation = new SelfieSegmentation({
        locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`,
      });
      selfieSegmentation.setOptions({ modelSelection: 1 });

      this.image = new Image();
      this.image.onload = () => {
        console.log("imgload!!!!!!!!!!!!!!!!!!!");
        if (type === 'img') {
          selfieSegmentation.onResults(this.handleSegmentationResults);
        } else {
          selfieSegmentation.onResults(this.handleSegmentationResults2);
        }

        const videoElement = JQuery("#soucevideo").get(0);
        Janus.attachMediaStream(videoElement, stream);
        videoElement.muted = "muted";

        let isSizeSet = false;
        videoElement.removeEventListener("playing", videoElement.playingListener);
        videoElement.playingListener = async  () =>{
          console.log("playing!!!!!!");
          if (this.rafId) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
          }
          var soucevideo = videoElement;
          if (!isSizeSet && soucevideo.videoWidth > 0 && soucevideo.videoHeight > 0) {
            this.$refs.myCanvas.width = soucevideo.videoWidth;
            this.$refs.myCanvas.height = soucevideo.videoHeight;
            this.image.width = soucevideo.videoWidth;
            this.image.height = soucevideo.videoHeight;
            isSizeSet = true;
          }
          let lastTime = performance.now();
          const minFrameInterval = 1000 / 15;
          const getFrames = async () => {
            console.log("22222");
            if (!this.context || !selfieSegmentation) {
              return;
            }
            const now = performance.now();
            if (now - lastTime >= minFrameInterval) {
              await selfieSegmentation.send({ image: soucevideo });
              lastTime = now;
            }
            this.rafId = requestAnimationFrame(getFrames);
          };
          await getFrames();
        };
        videoElement.addEventListener("playing", videoElement.playingListener);
        videoElement.play();
      };

      if (user.backgroundpath) {
        console.log('111111');
        this.image.src = process.env.NODE_ENV !== "development"
            ? "getBackGroundImage/" + user.backgroundpath
            : "api/getBackGroundImage/" + user.backgroundpath;
      } else {
        console.log('22222222');
        this.image.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAIAAAACDbGyAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wQFACsJ9b/0CwAAAA1JREFUGNNjYGBg+E+A8e/H4IIJZ2BgYAQA20BkOQZiUjQAAAAASUVORK5CYII=";
      }
    },
    // 虚拟背景
    handleSegmentationResults(results) {
      console.log("11111");
      if (!this.context || !results || !results.segmentationMask || !results.image) {
        return;
      }
      // 绘制画像
      // Prepare the new frame
      this.context.save();
      this.context.clearRect(0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.drawImage(results.segmentationMask, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      // 计算背景图片的尺寸和位置，以便其占满整个视频区域
      const canvasAspectRatio = this.$refs.myCanvas.width / this.$refs.myCanvas.height;
      const imageAspectRatio = this.image.width / this.image.height;
      let drawWidth, drawHeight;
      if (canvasAspectRatio > imageAspectRatio) {
        drawWidth = this.$refs.myCanvas.width;
        drawHeight = drawWidth / imageAspectRatio;
      } else {
        drawHeight = this.$refs.myCanvas.height;
        drawWidth = drawHeight * imageAspectRatio;
      }
      const offsetX = (this.$refs.myCanvas.width - drawWidth) / 2;
      const offsetY = (this.$refs.myCanvas.height - drawHeight) / 2;

      // Only overwrite existing pixels.
      this.context.globalCompositeOperation = "source-out";
      this.context.drawImage(this.image, offsetX, offsetY, drawWidth, drawHeight);
      // this.context.drawImage(this.image, 0, 0, this.image.width, this.image.height, 0, 0
      //     , this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      // Only overwrite missing pixels.
      this.context.globalCompositeOperation = "destination-atop";
      this.context.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.restore();
    },
    // 虚化背景
    handleSegmentationResults2(results) {
      console.log("11111");
      if (!this.context ) {
        return;
      }
      this.context.save();
      this.context.clearRect(0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      // 先画上分割蒙版
      this.context.drawImage(results.segmentationMask, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      this.context.globalCompositeOperation = "source-out";

      // 创建一个新的Canvas用于模糊处理
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = this.$refs.myCanvas.width;
      tempCanvas.height = this.$refs.myCanvas.height;
      let tempCtx = tempCanvas.getContext('2d');
      tempCtx.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      // StackBlur.canvasRGBA(tempCtx, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height, 10);
      // 使用StackBlur进行模糊处理
      StackBlur.canvasRGBA(tempCanvas, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height, 50);

      // 将模糊后的图像画回主Canvas
      this.context.drawImage(tempCanvas, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);

      this.context.globalCompositeOperation = "destination-atop";

      // 绘制前景图像
      this.context.drawImage(results.image, 0, 0, this.$refs.myCanvas.width, this.$refs.myCanvas.height);
      this.context.restore();
    },

    // 底部菜单值变更
    changeCheckBoxValue(key){
      this.tool_value[key] = !this.tool_value[key];
    },
    stopWebSpeech(){
      console.log("关闭");
      this.audioEndFlg = true;
      if(this.recognition){
        this.recognition.stop();
      }
    },
    async startWebSpeech(){
      console.log("开启");
      this.audioEndFlg = false;
      if(this.recognition){
        this.recognition.start();
      }else{
        let SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new SpeechRecognition();
        // 设置识别语言
        this.recognition.lang = 'ja-JP';
        // this.recognition.lang = 'zh-CN';
        // 设置连续识别
        this.recognition.continuous = true;
        // 返回临时结果
        this.recognition.interimResults = false;
        // 返回的可能匹配值的数量 默认值1
        this.recognition.maxAlternatives = 1;
        // 开始识别
        this.recognition.start();
        let userRet = await RefreshUserInfo();
        let userInfo = userRet.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(userInfo));
        // 接收、处理结果
        this.recognition.onresult = (event) => {
          var last = event.results.length - 1;
          if(event.results[last][0].transcript && event.results[last][0].transcript !=""){
            var date = new Date();
            let msg = {
              uid:date.getTime().toString()+Math.random().toString(36).substr(2, 4),
              method:"audioToTextShow",
              text:userInfo.name + ":" + event.results[last][0].transcript,
            }
            this.setAudioText("自身:" + event.results[last][0].transcript)
            // 同步发送给对方
            console.log("发送给对方");
            this.sendMessageToAll(msg);
          }
        };
        this.recognition.onerror = (event)=>{
          console.log('エラー: ' + event.error);
        };
        this.recognition.onend = () => {
          if(!this.audioEndFlg){
            this.recognition.start();
          }
        };
      }
    },
    janusReceiveMsg(data){
      console.log("ondata");
      console.log(data);
      // 重复判定
      if (!this.receiveMsgUid) {
        this.receiveMsgUid = new Set();
      }
      if (this.receiveMsgUid.has(data['uid'])) {
        console.log("重复消息，已忽略:", data['uid']);
        return;
      }
      this.receiveMsgUid.add(data['uid']);
      // 接受消息处理
      if(data['method'] == "audioToTextShow"){
        // 语音转文字对方显示
        this.setAudioText(data['text'])
      }else if(data['method'] == "changeVideoOrAudioShow"){
        this.feedStreams.forEach((item) => {
          if (item[0].user_id == data['user_id']) {
            item[0].showVideo = data['video'];
            item[0].showAudio = data['audio'];
          }
        });
      }
    },
    sendChangeVideoOrAudioMessage(){
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      var date = new Date();
      let msg = {
        uid:date.getTime().toString()+Math.random().toString(36).substr(2, 4),
        method:"changeVideoOrAudioShow",
        video:this.localStream.showLocalVideo,
        audio:this.localStream.showLocalAudio,
        user_id:userInfo.login_account_id
      }
      this.sendMessageToAll(msg);
    },
    sendMessageToAll(msg){
      this.sfutest.data({
        text: JSON.stringify(msg),
        error: function () {console.log('エラー');},
        success: function () {},});
    },
    setAudioText(text){
      this.audioText.push(text);
      this.$nextTick(() => {
        this.$refs.audioTextRef.scrollTop = this.$refs.audioTextRef.scrollHeight;
      });
    },
    // speaker模式滚动用方法
    mouseDownHandler(e) {
      e.stopPropagation();
      e.preventDefault();
      if(!this.isMobile){
        this.pageX  = e.pageX ;
        this.startScrollLeft  = this.$refs.speakDiv1Ref.scrollLeft;
        this.isMouseDown = true;
      }
    },
    mouseMoveHandler(e) {
      e.stopPropagation();
      e.preventDefault();
      if(!this.isMobile){
        if(this.isMouseDown){
          const diff = this.pageX  - e.pageX ;
          this.$refs.speakDiv1Ref.scrollLeft  = this.startScrollLeft  + diff;
        }
      }
    },
    mouseUpHandler(e) {
      e.stopPropagation();
      e.preventDefault();
      if(!this.isMobile){
        this.isMouseDown = false;
      }
    },
    async changeCamera(){
      // 左上角旋转摄像头
      if(this.localStream.showLocalVideo){
        // 前置后置初始化
        if(this.facingMode == 'user'){
          this.facingMode = 'environment';
        }else{
          this.facingMode = 'user';
        }
        let check = await this.getSendStream();
        if(check){
          this.sfutest.createOffer({tracks: [{
              type: 'video', replace: true, capture: this.sendStream.getVideoTracks()[0]
            }],});
        }
      }
    },
    arrowDivStyle(type){
      let arrowDivStyle;
      if(this.viewType == 'grid'){
        arrowDivStyle = {height:'100%',display:'flex' };
        // 显示设置
        if(type == 'left' && this.page_num <= 1){
          arrowDivStyle['display']= 'none';
        }else if(type == 'right' && this.page_num == this.page_total){
          arrowDivStyle['display']= 'none';
        }
      }else{
        arrowDivStyle = {display:'none'}
      }

      return arrowDivStyle;
    },
    arrowImgStyle(type){
      let arrowStyle;
      if(this.viewType == 'grid'){
        arrowStyle = {width:'20px'};
      }else{
        arrowStyle = {marginTop:this.item_height/2+'px'};
      }
      if(type == 'left'){
        arrowStyle['transform'] = 'scaleX(-1)'
      }
      return arrowStyle;
    },
    goPage(num){
      this.page_num = this.page_num + num;
      this.calcVideoSize();
    },
    gridDiv(type,index){
      let gridDiv;
      gridDiv = {height: this.item_height+'px',width: this.item_width+'px',position: 'relative',margin:'5px'
        ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      if(type == 'local'){
        // 自己视频不是第一页就隐藏
        if(this.page_num > 1){
          gridDiv['display'] = 'none';
        }
      }else{
        // 其他用户显示要计算
        if(index !== null && index !== undefined){
          let minValue = (this.page_num - 1 ) * this.page_user + 1;
          let maxValue = this.page_num * this.page_user ;
          index = index +2 ;
          if(index < minValue || index > maxValue){
            gridDiv['display'] = 'none';
          }
        }
      }
      return gridDiv;
    },
    gridNoVideo(){
      let gridNoVideo;
      let calcHeight = this.item_height*3/5;
      let clacWidth = this.item_width*3/5;
      let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
      gridNoVideo = {height: setValue+'px',width: setValue+'px'};
      return gridNoVideo;
    },
    speakDiv1(){
      // 副视图
      let speakDiv ;
      if(this.feedStreams.length <=0){
        // 没有的话 display:none
        speakDiv = {display:'none'};
      }else if(this.feedStreams.length<=1){
        speakDiv = { position: 'absolute', right: 0, top: 0, border: 'gray solid 1px', zIndex: 1
          ,height: this.speaker_height/3+'px',width: this.speaker_width/3+'px'
          ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }else{
        speakDiv = {height: this.item_height+'px',width: '100%',fontSize:'12px',margin:'0 2px 0 0'
          ,overflowX: 'auto',overflowY:'hidden',whiteSpace:'nowrap',display:'flex'};
      }
      return speakDiv;
    },
    speakVideoDiv1(user){
      // 副视图
      let speakVideoDiv1;
      if(this.feedStreams.length <=1){
        speakVideoDiv1 = { position: 'absolute', right: 0, top: 0, border: 'gray solid 1px', zIndex: 1
          ,height: this.speaker_height/3+'px',width: this.speaker_width/3+'px'
          ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }else{
        speakVideoDiv1 = {position:'relative',height: this.item_height+'px'
          ,display: 'inline-flex',justifyContent: 'center',alignItems: 'center',fontSize:'12px',margin:'0 2px 0 0'
          ,flexShrink: '0',minWidth:this.item_height+'px',
        };
      }
      if(this.shareScreenUser) {
        // 屏幕共享的不显示在上面
        if( user == 'screen-share_'+ this.shareScreenUser){
          speakVideoDiv1['display'] = 'none';
        }
      }else if(this.feedStreams.length == 1){
        // 两个人的时候 自己固定显示在右上角
        if(user !== 'local'){
          speakVideoDiv1['display'] = 'none';
        }
      }else{
        if(user == 'local'){
          if(this.speaking_user == null){
            speakVideoDiv1['display'] = 'none';
          }
        }else{
          if(this.speaking_user == user){
            speakVideoDiv1['display'] = 'none';
          }
        }
      }
      return speakVideoDiv1;
    },
    speakDiv2(){
      // 主视图
      let speakDiv ;
      if(this.feedStreams.length <=0){
        speakDiv = { height: this.speaker_height+'px',width: this.speaker_width+'px'
          ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }else if(this.feedStreams.length <=1){
        speakDiv = {height: '100%',width: '100%',
          position: 'absolute',bottom: top, left: 0,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }
      return speakDiv;
    },
    speakVideoDiv2(user){
      let speakVideoDiv2 ;
      // 主视图
      if(this.feedStreams.length  <=1){
        speakVideoDiv2 = { height: this.speaker_height+'px',width: this.speaker_width+'px'
          ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }else{
        // 宽度加上三个间隔 2px*3
        speakVideoDiv2 = {height: this.speaker_height+'px',width: this.speaker_width+6+'px',
          position: 'absolute',bottom: 0, left: 0
          ,display: 'flex',justifyContent: 'center',alignItems: 'center'};
      }
      // 处于共享屏幕模式
      if(this.shareScreenUser){
        if( user !== 'screen-share_'+ this.shareScreenUser){
          speakVideoDiv2['display'] = 'none';
        }
      }else if(this.feedStreams.length == 1){
        // 两个人的时候 对方固定显示大的
        if(user == 'local'){
          speakVideoDiv2['display'] = 'none';
        }
      }else{
        // 正常speaker模式检测
        if(user == 'local'){
          if(this.speaking_user !== null){
            speakVideoDiv2['display'] = 'none';
          }
        }else{
          if(this.speaking_user !== user){
            speakVideoDiv2['display'] = 'none';
          }
        }
      }
      return speakVideoDiv2;
    },
    localNoVideoStyle(){
      let localNoVideoStyle;
      if(this.feedStreams.length <=1){
        let calcHeight = this.speaker_height*3/5;
        let clacWidth = this.speaker_width*3/5;
        let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
        localNoVideoStyle = {height: setValue+'px',width: setValue+'px'};
      }else{
        let calcHeight = this.speaker_height*3/5;
        let clacWidth = this.speaker_width*3/5;
        let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
        localNoVideoStyle = {height: setValue+'px',width: setValue+'px'};
      }
      return localNoVideoStyle;
    },
    solidBoxStyleGrid(){
      let solidBoxStyle;
      if(this.viewType !=='grid'){
        solidBoxStyle = {display:'none'};
      }else{
        solidBoxStyle = { gridTemplateColumns: 'repeat('+this.columnsCount+', 1fr)',display: 'grid',overflow: 'auto',maxHeight:'100%',};
      }
      return solidBoxStyle;
    },
    solidBoxStyleSpeaker(){
      let solidBoxStyle;
      if(this.viewType =='grid') {
        solidBoxStyle = {display: 'none'};
      }else{
        if(this.feedStreams.length <=1){
          solidBoxStyle = {height: this.speaker_height+'px',width: this.speaker_width+'px',
            position: 'relative',display: 'flex',justifyContent: 'center',alignItems: 'center'};
        }else{
          // 高度+2上方speaker和中间大屏的间隔
          // 宽度+8
          solidBoxStyle = {display: 'flex',position: 'relative', height:this.speaker_height+this.item_height+2+'px',width:this.speaker_width+8+'px'};
        }
      }
      return solidBoxStyle;
    },
    remoteNoVideoStyle(){
      let remoteNoVideoStyle;
      if(this.viewType == 'grid'){
        let calcHeight = this.item_height*3/5;
        let clacWidth = this.item_width*3/5;
        let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
        remoteNoVideoStyle = {height: setValue+'px',width: setValue+'px',};
      }else{
        if(this.feedStreams.length <=1){
          let calcHeight = this.speaker_height/9;
          let clacWidth = this.speaker_width/9;
          let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
          remoteNoVideoStyle = {height: setValue+'px',width: setValue+'px'};
        }else{
          let calcHeight = this.item_height*0.7;
          let clacWidth = this.item_width*0.7;
          let setValue = calcHeight>clacWidth?clacWidth:calcHeight;
          remoteNoVideoStyle = {height: setValue+'px',width: setValue+'px'};
        }
      }
      return remoteNoVideoStyle;
    },
    calcSize(boxWidth,boxHeight,row,column){
      this.columnsCount = column;

      // 20240607 尝试调整视频比例
      let maxWidth = (boxWidth - 10 * column)/column;
      let maxHeight = (boxHeight - 10 * row)/row;
      if(row == 1 && column == 1){
        // 主画面
        this.speaker_height = maxHeight* 3/4;
        this.speaker_width = maxWidth;
        // 上方画面
        this.item_height = maxHeight*1/4;
        this.item_width = maxWidth*1/4;
      }else{
        this.item_height = maxHeight;
        this.item_width = maxWidth;
      }
      return;
    },
    calcVideoSize(){
      // 1是自己 feedStreams是其他人
      let total_users = this.feedStreams.length + 1 ;
      // 页容纳人数判断
      let innerWidth,innerHeight;
      innerWidth = window.innerWidth
      innerHeight = window.innerHeight
      const width = innerWidth -50;
      const height = innerHeight - 46 -70 -20;
      if(this.viewType == 'grid'){
        if(innerWidth < 991){
          this.page_user = 8;
        }else {
          this.page_user = 9;
        }
      }else{
        this.page_user = 5;
      }
      let page_total_num = Math.ceil(total_users / this.page_user);
      this.page_total = page_total_num;
      // 确保页码在有效范围内
      if (this.page_num > page_total_num) {
        this.page_num = page_total_num;
      }
      if (this.page_num < 1) {
        this.page_num = 1;
      }
      let current_page_users;
      if (this.page_num === 1) {
        // 第一页：计算包含自己在内的用户数
        current_page_users = Math.min(this.page_user, total_users);
      } else {
        // 其他页：只计算其他用户的数量
        const remainingUsers = this.feedStreams.length - ((this.page_num - 1) * this.page_user - 1);
        current_page_users = Math.min(this.page_user, Math.max(0, remainingUsers));
      }
      if(this.viewType == 'grid'){
        // ギャラリービュー
        if(innerWidth < 991){
            // 手机样式
          if(current_page_users  <= 1){
            // 如果是1 独占
            this.item_height = height;
            this.item_width = width;
            this.columnsCount = 1;
          }else if(current_page_users  <= 2){
            this.calcSize(width,height,2,1)
          }else if(current_page_users  <= 3){
            this.calcSize(width,height,2,2)
          }else if(current_page_users  <= 4){
            this.calcSize(width,height,2,2)
          }else if(current_page_users  <= 5){
            this.calcSize(width,height,3,2)
          }else if(current_page_users  <= 6){
            this.calcSize(width,height,3,2)
          }else if(current_page_users  <= 7){
            this.calcSize(width,height,4,2)
          }else if(current_page_users  <= 8){
            this.calcSize(width,height,4,2)
          }
        }else{
          this.page_user = 9;
          if(current_page_users  <= 1){
            // 如果是1 独占
            this.item_height = height;
            this.item_width = width;
            this.columnsCount = 1;
          }else if(current_page_users  <= 2){
            this.calcSize(width,height,1,2)
          }else if(current_page_users  <= 3){
            this.calcSize(width,height,2,2)
          }else if(current_page_users  <= 4){
            this.calcSize(width,height,2,2)
          }else if(current_page_users  <= 5){
            this.calcSize(width,height,2,3)
          }else if(current_page_users  <= 6){
            this.calcSize(width,height,2,3)
          }else if(current_page_users  <= 7){
            this.calcSize(width,height,3,3)
          }else if(current_page_users  <= 8){
            this.calcSize(width,height,3,3)
          }else if(current_page_users  <= 9){
            this.calcSize(width,height,3,3)
          }
        }
      }else{
        // スピーカービュー
        if(current_page_users <= 2){
          // 只有自己 占满
          this.speaker_height = height;
          this.speaker_width = width;
          this.columnsCount = 1;
        }else{
          this.calcSize(width,height,1,1)
        }
      }
    },
    async cilckShareScreen(){
      if(!this.shareScreenClickAble){
        return;
      }
      if(this.shareScreenUser){
        if(this.shareScreenUser == this.myaccountid){
          Toast("共有中です。");
        }else{
          Toast("他の人が共有中ですので、お待ちください。");
        }

        return;
      }
      this.shareScreenClickAble = false;
      // 初始化
      this.closeShareScreen();
      // 进入流程
      if(!this.checkedShareScreen){
        // 开启屏幕共享
        try{
          this.registerShareScreen();
          this.checkedShareScreen = true;
        }catch(error){
          // 关闭屏幕共享
          this.closeShareScreen();
          this.checkedShareScreen = false;
        }
      }else{
        // 关闭屏幕共享
        this.closeShareScreen();
        this.checkedShareScreen = false;
      }
      this.shareScreenClickAble = true;
    },
    closeShareScreen(){
      // 关闭屏幕共享
      if(this.screenShareHandle){
        // this.screenShareHandle.hangup();
        var hangup = { request: "leave" };
        this.screenShareHandle.send({ message: hangup });
      }
    },
    // init janus
    async JanusInit() {
      // 获取麦克风权限
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        // 停止所有的轨道，释放资源
        await stream.getTracks().forEach(track => track.stop());
      } catch (error) {
        this.audioPermission = false;
        this.localStream.showLocalAudio = false;
      }
      // 获取摄像头
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        // 停止所有的轨道，释放资源
        await stream.getTracks().forEach(track => track.stop());
      } catch (error) {
        this.videoPermission = false;
        this.localStream.showLocalVideo = false;
      }
      document.addEventListener('click', () => {
        const audioElements = document.querySelectorAll('audio[id^="remoteAudio"]');
        audioElements.forEach(audio => {
          // 检查是否正在播放
          if (audio.paused) {
            audio.play().catch(e => console.log('Audio play failed:', e));
          }
        });
      });
      // }, { once: true });

      Janus.init({
        debug: "all",
        callback: () => {
          if (!Janus.isWebrtcSupported()) {
            alert("No WebRTC support... ");
            return;
          }
          //只有成功时，才能继续,去掉了janus_ok变量
          this.createJanusSession();
        },
      });
    },
    createJanusSession() {
      let serverStunUrl='';
      let serverUserName= '';
      let serverUserCredential = ''
      const host = window.location.host;
      if (host.indexOf('localhost') !== -1) {
        // 本地开发环境
        serverStunUrl = 'turn:43.154.16.102:3478';
        serverUserName= 'lqf';
        serverUserCredential = '123456'
      } else if (host.indexOf('stg') !== -1) {
        // stg环境
        serverStunUrl = 'turn:52.194.48.148:3478';
        serverUserName= 'test';
        serverUserCredential = '12345678'
      } else {
        // 本番环境
        serverStunUrl = 'turn:35.78.136.103:3478';
        serverUserName= 'lqf';
        serverUserCredential = '123456'
      }

      let iceServers=[{urls: serverStunUrl,username: serverUserName, credential: serverUserCredential}];

      this.janus = new Janus({
        server: this.janus_server,
        iceServers: iceServers,
        success: () => {
          //创建session成功时
          //添加插件！
          this.attachVideoRoom();
        },
        error:  (error) => {
          Janus.error(error);
          history.back();
        },
        destroyed: function () {
          // window.location.reload();
        },
      });
    },
    attachVideoRoom() {
      //在初期化成功之后，调用此函数
      this.janus.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: this.opaqueId,
        success: (pluginHandle) => {
          //插件初始化成功时!
          this.sfutest = pluginHandle;
          this.createRoom();
          this.registerRoomUser();
        },
        error: (error) => {
          Janus.error("  -- Error attaching plugin...", error);
        },
        consentDialog: (on) => {
          //如果没有权限，这里需要让用户给权限？
        },
        iceState: (state) => {
          //iceState 主要用于标识 ICE 连接的状态，包括新建连接、连接中、连接成功等状态
          // disconnected
          console.log("ICE state changed to " + state);
          if(state == "disconnected"){
            if (this.dialogSpeed) return;
            this.dialogSpeed = Dialog.alert({
              title: 'ネットワークエラー',
              confirmButtonText: '再読み込み',
              message: 'インターネットに接続できませんでした。\n' +
                  '通信環境や端末の設定をご確認の上、\n' +
                  '再度おためしてください。',
            });
            this.dialogSpeed.then(() => {
                // 网络恢复时关闭对话框
                this.dialogSpeed = null;
            });
            this.dialogSpeed.close = () => {
              if (this.dialogSpeed) {
                // 通过触发按钮的点击事件来关闭对话框
                document.querySelector('.van-dialog__confirm').click();
              }
            };
          }else if(state == "connected"){
            if (this.dialogSpeed) {
              this.dialogSpeed.close();
              this.dialogSpeed = null;
            }
          }
        },
        mediaState: (medium, on, mid) => {
          //audio video 两种!
          //        mediaState 是用于标识媒体通道状态的事件，用于检测并通报媒体通信状态。在 Janus 中，mediaState 事件通常在以下情况下被调用：

          // 当媒体通信连接中断时，会调用mediaState事件通知应用程序。
          // 当Janus服务器检测到媒体通信连接中存在媒体包的丢失、延迟等问题时，也会调用mediaState事件。
          // 当媒体流速率变化时，也会调用mediaState事件。
          console.log("mediaState changed to " + on);
        },
        webrtcState: (on) => {
          console.log("webrtcState changed to " + on);
          // this.sfutest.setMaxBitrate(512);
          // this.sfutest.send({message: { request: "configure", bitrate: 256000 },});
        },
        slowLink: (uplink, lost, mid) => {
          //网络不好的时候调用，这时候应该关闭自己的视频，但通过chrome测试好像没有触发！
          console.log("network slow!");
        },
        onmessage: (msg, jsep) => {
          console.log("msg",msg)
          //当收到消息时调用
          //获取event的类型
          let event = msg["videoroom"];
          if (event) {
            if (event === "joined") {
              //当自己加入到房间时
              //myid: 不确定代表什么
              this.myid = msg["id"];
              //mypvtid：加入房间之后，应该是代表自己的id，后面会用于订阅别人
              this.mypvtid = msg["private_id"];
              //TODO:一定要发布自己吗
              this.publishMyFeed();

              //当前已经有发布者时
              //订阅并处理来自远程用户的媒体流
              if (msg["publishers"] && msg["publishers"].length>0 ) {
                console.log("已经有发布者");
                let list = msg["publishers"];
                console.log(list);
                this.newRemoteFeed(list,"init");
              }else{
                console.log("没有发布者");
              }
            } else if (event === "destroyed") {
              // TODO: 这里需要做什么处理呢
              Janus.warn("The room has been destroyed!");
            } else if (event === "event") {
              // 收到event：自己的stream，新的发布者（有人加入），有人离开，有人不发布了，error
              if (msg["streams"]) {
                //实际意义不大—？
                let streams = msg["streams"];
                for (let i in streams) {
                  let stream = streams[i];
                  stream["id"] = this.myid;
                  stream["display"] = this.myusername;
                }
              } else if (msg["publishers"]) {
                console.log("有发布者加入");
                let list = msg["publishers"];
                this.newRemoteFeed(list,"update");
              } else if (msg["leaving"]) {
                // 页面刷新时，会先触发unpublished，然后触发 leaving
                //删除离开者
                let leaving = msg["leaving"];
                Janus.log("Publisher leaving: " + leaving);

                if (leaving == "ok") {
                  this.closeShareScreen();
                  if(this.multiCallUserType){
                    const realParticipants = this.feedStreams.filter(stream =>
                        !stream[0].display.includes('画面共有')
                    ).length;
                    if(realParticipants == 0){
                      var destroy = {request: "destroy", room: this.roomid};
                      this.sfutest.send({
                        message: destroy,
                        success: () => {this.afterLeave();},
                        error: () => {this.afterLeave();}
                      });
                    }else{
                      this.afterLeave();
                    }
                  }else{
                    this.afterLeave();
                  }
                } else {
                  for (let index = 0; index < this.feedStreams.length; index++) {
                    if (this.feedStreams[index][0].id == leaving) {
                      // 屏幕共享退出
                      if(this.feedStreams[index][0].display == '画面共有'){
                        this.shareScreenUser = null;
                      }
                      // 清空正在说话
                      this.speaking_user = null;
                      this.feedStreams.splice(index, 1);
                      // 重新布置视频流
                      // this.setLocalVideo();
                      // this.setRemoteVideo();
                      // 重新计算屏幕
                      this.calcVideoSize();
                      break;
                    }
                  }
                }
              } else if (msg["unpublished"]) {
                //TODO 什么时候会触发 unpublished
                let unpublished = msg["unpublished"];
                Janus.log("Publisher unpublished: " + unpublished);
                if (unpublished === "ok") {
                  // 自己挂断
                  this.closeShareScreen();
                  this.sfutest.hangup();
                  return;
                }
              } else if (msg["error"]) {
                if (msg["error_code"] === 426) {
                  // This is a "no such room" error: give a more meaningful description
                  console.log("error! room does not exist!");
                } else {
                  console.log(msg["error"]);
                }
              }
            }else if (event ==='talking'){
              // 自己加上一个对方的时候，平铺模式不需要切换,
              if(this.feedStreams.length< 2 || this.viewType == 'grid'){
                return;
              }
              let break_flg = false;
              for(let i=0;i<this.feedStreams.length;i++){
                for(let j=0;j<this.feedStreams[i].length;j++){
                  if(this.feedStreams[i][j]['id'] && this.feedStreams[i][j]['id'] == msg["id"]){
                    this.speaking_user = this.feedStreams[i][j]['user_id'];
                    console.log("speaking："+this.feedStreams[i][j]['user_id']);
                    break_flg = true;
                    break;
                  }
                }
                if(break_flg){
                  break;
                }
              }
              // 否则就是自己在说话
              if( !break_flg){
                this.speaking_user = null;
              }
            }
          } else {
            console.error("event is null!");
          }

          //handleRemoteJsep
          if (jsep) {
            this.sfutest.handleRemoteJsep({ jsep: jsep });
            //TODO: 这里需要判断本地音视频流是否未获取成功，比如被拒绝
          }
        },
        onlocaltrack: (track, on) => {
          //当获取到本地音视频流时，会调用这里！
          // 替换视频时也会调用（虚拟背景、模糊背景）
          console.log("本地媒体流状态变化!");
          let trackId = track.id.replace(/[{}]/g, "");
          if(!on) {
            // Track removed, get rid of the stream and the rendering
            let stream = this.localTracks[trackId];
            if(stream) {
              try {
                let tracks = stream.getTracks();
                for(let i in tracks) {
                  let mst = tracks[i];
                  if(mst !== null && mst !== undefined)
                    mst.stop();
                }
              } catch(e) {}
            }
            delete this.localTracks[trackId];
            return;
          }
          // If we're here, a new track was added
          let stream = this.localTracks[trackId];
          if(stream) {
            // We've been here already
            return;
          }
          if(track.kind !== "audio") {
            // stream = new MediaStream([track]);
            // this.localTracks[trackId] = stream;
            // this.sendStream = stream;
          }
          this.setLocalVideo();
          // this.setRemoteVideo();
        },
        onremotetrack: (track, mid, on) => {
          console.log("onremotetrack");
        },
        oncleanup: () => {
          this.localStream = {showLocalVideo: false,showLocalAudio: false};
          this.localTracks= {};
          // this.feedStreams = [];
          if(this.$route.path =='/roomConversation'){
            history.back();
          }
        },
      });
    },
    async publishMyFeed() {
      //发布自己
      //tracks:设置音频，视频等
      let tracks = [];
      if(this.audioPermission) {
        tracks.push({type: "audio", capture: true, recv: false});
      }else{
        tracks.push({type: "audio", capture: false, recv: false});
      }
      if(this.localStream.showLocalVideo){
        let check = await this.getSendStream();
        if(check){
          tracks.push({type: "video", capture:this.sendStream.getVideoTracks()[0]
            , recv: false, simulcast: this.doSimulcast});
          this.firstSendVideoStream = false;
        }
      }else{
        tracks.push({ type: "video", capture: false, recv: false });
        this.firstSendVideoStream = true;
      }
      tracks.push({ type: "data" });
      //每个参与房间的用户都会通过信令服务器相互交换等待发送和接收音视频媒体流的信息
      this.sfutest.createOffer({
        tracks: tracks,
        customizeSdp: () => {},
        success: (jsep) => {
          console.log("create offer success!");
          // 第一次加载，不加载发布不出来,此时设置video、audio无效
          let publish = {request: "configure",data: true};
          this.sfutest.send({ message: publish, jsep: jsep });
          if(!this.localStream.showLocalAudio){
            this.sfutest.muteAudio();
          }
          this.sendChangeVideoOrAudioMessage();
        },
        error: (error) => {
          //发生错误时，暂不处理
          Janus.error("WebRTC error:", error);
        },
      });
    },
    async getSendStream(){
      let stream;
      try {
        // 获取用户媒体流 // 720p
        stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: {
            width: { ideal: 480 },
            height: { ideal: 480 },
            frameRate: { ideal: 30 },
            facingMode: this.facingMode
          } });
      } catch (error) {
        // 捕获错误并显示提示信息
        Toast("カメラ権限が異常です。");
        return false;
      }
      if(stream){
        if(this.tool_value.checkedBackground){
          // 检测虚拟背景图片
          let user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
          if(!user.backgroundpath){
            this.tool_value.checkedBackground = false;
            Toast.fail("背景画像をアップロードしてください");
            return false;
          }
          // 开启虚拟背景
          this.createCanvas(stream,'img');
          this.sendStream = this.$refs.myCanvas.captureStream();
          return true;
        }else if (this.tool_value.checkedBlurBackground){
          // 开启模糊背景
          this.createCanvas(stream,'back');
          this.sendStream = this.$refs.myCanvas.captureStream();
          return true;
        }else{
          this.stopCanvas();
          this.sendStream = stream;
          return true;
        }
      }else{
        return false;
      }
    },
    //订阅并处理远程媒体流
    //对方调用createoffer之后才能到这里！
    //应该有2个调用位置：1.用户加入房间时，对已经存在的用户进行订阅。2.订阅新添加的用户
    newRemoteFeed(list,type) {
      console.log("订阅远程");
      let needUpdateUI = false;

      for (let f in list) {
        console.log(list[f]);

        if (list[f]["dummy"]) continue;
        let id = list[f]["id"];
        let registerName = list[f]["display"];
        var lastIndexOfUnderscore = registerName.lastIndexOf("_");
        let last = registerName.substring(lastIndexOfUnderscore + 1);
        let first = registerName.substring(0, lastIndexOfUnderscore);
        let user_id,display;

        if(first == "screen-share"){
          user_id = registerName
          display = "画面共有";
          this.shareScreenUser = last;
        }else{
          user_id =  last;
          display = first;
        }
        let streams = list[f]["streams"];

        console.log("注册的user_id",user_id);
        if(user_id == this.multiCallUser){
          // 如果邀请的人加入了room，上方按钮不再显示
          this.multiCallUser = null;
        }

        // 如果该流属于自己 跳过
        if(user_id == this.myaccountid && display != "画面共有") {
          if(type == 'init' && id !== this.sfutest.id){
            // 踢掉之前的相同userId
            this.sfutest.send({message: {request: "kick", room: this.roomid, id: id}});
          }
          continue;
        }

        for (let i in streams) {
          let stream = streams[i];
          stream["id"] = id;
          stream["user_id"] = user_id;
          stream["display"] = display;
        }

        let findIndex = -1;
        for (let i = 0; i < this.feedStreams.length; i++) {
          if (this.feedStreams[i][0].user_id == user_id) {
            findIndex = i;
          }
        }

        //避免同一个人的视频被多次添加！
        if (findIndex != -1) {
          this.feedStreams[findIndex] = streams;
        } else {
          this.feedStreams.push(streams);
          needUpdateUI = true;
        }
        //加入到本地
        let remoteFeed = null;
        this.janus.attach({
          plugin: "janus.plugin.videoroom",
          opaqueId: this.opaqueId,
          success: (pluginHandle) => {
            remoteFeed = pluginHandle;
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
            remoteFeed.simulcastStarted = false;

            //
            let subscription = [];
            for (let i in streams) {
              let stream = streams[i];
              subscription.push({
                feed: stream.id, // This is mandatory
                mid: stream.mid, // This is optional (all streams, if missing)
              });
              // FIXME Right now, this is always the same feed: in the future, it won't
              remoteFeed.rfid = stream.user_id;
              remoteFeed.rfdisplay = this.escapeXmlTags(stream.display);
            }

            var subscribe = {
              request: "join",
              room: this.roomid,
              ptype: "subscriber",
              streams: subscription,
              //use_msid 不知道具体功能
              use_msid: false,
              private_id: this.mypvtid,
            };
            remoteFeed.send({ message: subscribe,});


          },
          error: (error) => {
            Janus.error("  -- Error attaching plugin...", error);
          },
          iceState: (state) => {
            Janus.log(
              "ICE state (feed #" + remoteFeed.rfindex + ") changed to " + state
            );
          },
          webrtcState: (on) => {
            console.log("webrtcState changed to " + on);
            // remoteFeed.setMaxBitrate(512);
            //远程流的状态!
            // remoteFeed.send({message: { request: "configure", bitrate: 256000 },});
          },
          slowLink: (uplink, lost, mid) => {
            console.log("slow!");
          },
          onmessage: (msg, jsep) => {
            console.log("msg",msg)
            let event = msg["videoroom"];
            if (msg["error"]) {
              console.log(msg["error"]);
            } else if (event) {
              if (event === "attached") {
                console.log("attached");
                //订阅成功时添加到用户列表？
              } else if (event === "event") {
                console.log("event");
                console.log(msg);
                let substream = msg["substream"];
                let temporal = msg["temporal"];
                if (
                  (substream !== null && substream !== undefined) ||
                  (temporal !== null && temporal !== undefined)
                ) {
                  if (!remoteFeed.simulcastStarted) {
                    remoteFeed.simulcastStarted = true;
                  }
                }
              }
            }

            if (jsep) {
              let stereo = jsep.sdp.indexOf("stereo=1") !== -1;
              // Answer and attach
              remoteFeed.createAnswer({
                jsep: jsep,
                tracks: [{ type: "data" }],
                customizeSdp: (jsep) => {
                  if (stereo && jsep.sdp.indexOf("stereo=1") == -1) {
                    // Make sure that our offer contains stereo too
                    jsep.sdp = jsep.sdp.replace(
                      "useinbandfec=1",
                      "useinbandfec=1;stereo=1"
                    );
                  }
                },
                success: (jsep) => {
                  let body = { request: "start", room: this.myroom };
                  remoteFeed.send({ message: body, jsep: jsep });
                },
                error: (error) => {
                  Janus.error("WebRTC error:", error);
                },
              });
              setTimeout(() => {
                this.sendChangeVideoOrAudioMessage();
              }, 3000);
            }
          },
          //不会调用local，无需处理
          onlocaltrack: (track, on) => {
            console.log("onlocaltrack");
          },
          onremotetrack: (track, mid, on) => {
            console.log("onremotetrack");
            if(this.shareScreenUser == this.myaccountid && display == "画面共有"){
              return;
            }
            if (!on) {
              delete remoteFeed.remoteTracks[mid];
              if (track.kind === "video") {
                this.feedStreams.forEach((item) => {
                  if (item[0].user_id == remoteFeed.rfid) {
                    item[0].showVideo = false;
                    item[0].videoStream = null;
                    if(item[0].bitInterval){
                      clearInterval(item[0].bitInterval);
                    }
                    item[0].bit = '';
                  }
                });
              }
              return;
            }

            // If we're here, a new track was added
            if(remoteFeed.remoteTracks[mid]){
              return;
            }
            let stream = new MediaStream([track]);
            remoteFeed.remoteTracks[mid] = stream;
            if (track.kind === "audio") {
              //将创建的stream设置给audio
              // Janus.attachMediaStream(JQuery("#remoteAudio" + remoteFeed.rfid).get(0), stream);
              // JQuery("#remoteAudio" + remoteFeed.rfid).get(0).play().catch(e =>
              //     console.log("#remoteAudio" + remoteFeed.rfid+'=>Audio play failed:', e));
              const tryAttachAudio = () => {
                const audioEl = JQuery("#remoteAudio" + remoteFeed.rfid).get(0);
                if (audioEl) {
                  Janus.attachMediaStream(audioEl, stream);
                  audioEl.play().catch(e =>
                      console.log("#remoteAudio" + remoteFeed.rfid + ' => Audio play failed:', e)
                  );
                } else {
                  console.warn("Audio element notfound，wait 200ms try again: " + remoteFeed.rfid);
                  setTimeout(tryAttachAudio, 200);
                }
              };
              tryAttachAudio();
            } else if (track.kind === "video") {
              console.log("onremotetrackVideo");
              //将创建的stream设置给audio
              //remoteVideo+index
              this.feedStreams.forEach((item) => {
                if (item[0].user_id == remoteFeed.rfid) {
                  item[0].showVideo = true;
                  item[0].videoStream = stream;
                  if(item[0].bitInterval){
                    clearInterval(item[0].bitInterval);
                  }
                  item[0].bitInterval = setInterval(()=> {
                    let bitrate = remoteFeed.getBitrate();
                    item[0].bit = bitrate;
                  },1000);
                  // this.setLocalVideo();
                  this.setRemoteVideo();
                }
              });
            }
          },
          ondata: (data) => {
            this.janusReceiveMsg(JSON.parse(data));
          },
          oncleanup: () => {
            //delete
            //这里通过v-if来处理？
            remoteFeed.remoteTracks = {};
            remoteFeed.remoteVideos = 0;
          },
        });
      }
      if(needUpdateUI){
        // this.setLocalVideo();
        // this.setRemoteVideo();
        this.calcVideoSize();
      }
      setTimeout(() => {
        this.sendChangeVideoOrAudioMessage();
      }, 3000);
    },
    escapeXmlTags(value) {
      if (value) {
        var escapedValue = value.replace(new RegExp("<", "g"), "&lt");
        escapedValue = escapedValue.replace(new RegExp(">", "g"), "&gt");
        return escapedValue;
      }
    },
    //创建房间？
    createRoom() {
      // let room_list= [1234,1,5678];
      // room_list.forEach((item)=>{
      //   var destroy = {
      //     request: "destroy",
      //     room: item,
      //   };
      //   this.sfutest.send({ message: destroy });
      // })
      var created = {
        request: "create",
        room: this.roomid,
        permanent: false,
        is_private: false,
        publishers: this.maxPublishersNum,
        audiolevel_ext : true,
        audiolevel_event : true,
        audio_active_packets : 50,
        audio_level_average : 40
      };
      this.sfutest.send({ message: created });
    },
    //注册用户到房间，成功后会收到join事件
    registerRoomUser() {
      RefreshUserInfo().then((res) => {
        const user = res.data.data.user;
        localStorage.setItem(process.env.VUE_APP_USER_KEY, JSON.stringify(user));
        this.myusername = user.name;
        this.myaccountid = user.login_account_id;
        //注册到房间
        //TODO:1,publisher 是否可以修改
        //TODO:2,user.name 是否会出错,重复注册？
        var register = {
          request: "join",
          room:  this.roomid,
          ptype: "publisher",
          display: user.name+"_"+user.login_account_id,
        };
        this.sfutest.send({ message: register });
      });
    },
    async registerShareScreen(){
      let serverStunUrl='';
      let serverUserName= '';
      let serverUserCredential = ''
      const host = window.location.host;
      if (host.indexOf('localhost') !== -1) {
        // 本地开发环境
        serverStunUrl = 'turn:43.154.16.102:3478';
        serverUserName= 'lqf';
        serverUserCredential = '123456'
      } else if (host.indexOf('stg') !== -1) {
        // stg环境
        serverStunUrl = 'turn:52.194.48.148:3478';
        serverUserName= 'test';
        serverUserCredential = '12345678'
      } else {
        // 本番环境
        serverStunUrl = 'turn:35.78.136.103:3478';
        serverUserName= 'lqf';
        serverUserCredential = '123456'
      }

      let iceServers=[{urls: serverStunUrl,username: serverUserName, credential: serverUserCredential}];
      this.screenShareJanus = new Janus({
        server: this.janus_server,
        iceServers: iceServers,
        success: () => {
          // 创建session成功时，添加屏幕共享插件
          this.attachScreenSharePlugin();
        },
        error:  (error)=> {
          Janus.error(error);
          this.closeShareScreen();
          this.checkedShareScreen = false;
        },
        destroyed:  ()=> {
          this.closeShareScreen();
          this.checkedShareScreen = false;
        },
      });
    },
    async attachScreenSharePlugin(){
      this.screenShareJanus.attach({
        plugin: "janus.plugin.videoroom",
        opaqueId: this.opaqueId + "_screenshare",
        success: (pluginHandle) => {
          // 插件初始化成功时
          this.screenShareHandle = pluginHandle;
          this.joinScreenShareRoom();
        },
        error: (error) => {
          Janus.error("Error attaching plugin...", error);
        },
        consentDialog: (on) => {
          Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
        },
        webrtcState: (on) => {
          Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
          // this.screenShareHandle.setMaxBitrate(512);
          // this.screenShareHandle.send({message: { request: "configure", bitrate: 256000 },});
        },
        onmessage: (msg, jsep) => {
          Janus.debug(" ::: Got a message (screen share) :::", msg);
          var event = msg["videoroom"];
          Janus.debug("Event: " + event);
          if (event != undefined && event != null) {
            if (event === "joined") {
              this.screenMyid = msg["id"];
              this.screenMypvtid = msg["private_id"];
              Janus.log("Successfully joined room " + msg["room"] + " with ID " + this.screenMyid);
              this.publishScreenShare();
            } else if (event === "destroyed") {
              // The room has been destroyed
              Janus.warn("The room has been destroyed!");
            } else if (msg["leaving"]) {
              let leaving = msg["leaving"];
              if (leaving == "ok") {
                this.screenShareHandle.hangup();
              }
            }
          }
          if (jsep !== undefined && jsep !== null) {
            Janus.debug("Handling SDP as well...", jsep);
            this.screenShareHandle.handleRemoteJsep({ jsep: jsep });
          }
        },
        onlocalstream: () => {},
        onremotestream: () => {},
        oncleanup: () => {}
      });
    },
    joinScreenShareRoom() {
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      let register = {request: "join",
          room: this.roomid,
          ptype: "publisher",
          display: "screen-share"+"_"+userInfo.login_account_id
        };
      this.screenShareHandle.send({ message: register });
    },
    publishScreenShare() {
      this.screenShareHandle.createOffer({
        media: { video: 'screen', audio: false, data: false },
        customizeSdp: (jsep) => {},
        success: (jsep) => {
          Janus.debug("Got publisher SDP!", jsep);

          let sdp = jsep.sdp;
          sdp = sdp.replace(/m=audio .*\r\n/g, ""); // 移除音频媒体描述
          sdp = sdp.replace(/a=rtpmap:\d+ opus\/\d+\r\n/g, ""); // 移除opus相关行

          let newJsep = { type: jsep.type, sdp: sdp };

          // 这里可以获取到WebRTC连接的所有发送者
          let pc = this.screenShareHandle.webrtcStuff.pc;
          let videoSender = pc.getSenders().find(sender => sender.track && sender.track.kind === 'video');
          if (videoSender && videoSender.track) {
            // 监听屏幕共享轨道的结束事件
            videoSender.track.addEventListener('ended', () => {
              console.log('Screen sharing has ended');
              this.closeShareScreen();
              this.checkedShareScreen = false;
            });
          }

          var publish = { request: "publish", audio: false, video: true, data: false };
          this.screenShareHandle.send({ message: publish, jsep: newJsep });
          // var publish2 = { request: "configure", bitrate: 200000 };
          // this.screenShareHandle.send({ message: publish2 });
        },
        error: (error) => {
          Janus.error("WebRTC error:", error);
          this.closeShareScreen();
          this.checkedShareScreen = false;
        }
      });
    },
    //修改video的状态
    async changeVideoOrAudio(type) {
      console.log("changeVideoOrAudio============"+type);
      //如果本来音视频是没有打开的，那么需要创建offer？
      if (type == "video") {
        if(!this.videoPermission){
          Toast("カメラ権限が異常です。");
          return;
        }
        this.localStream.showLocalVideo = !this.localStream.showLocalVideo;
        this.$router.replace({
          path: this.$route.path,
          query: {...this.$route.query, cameraOpen: this.localStream.showLocalVideo}
        });
        if (!this.localStream.showLocalVideo || !this.firstSendVideoStream) {
          // 关闭摄像头 或 已经发布过视频流的情况
          const publish = {
            request: "configure",
            video: this.localStream.showLocalVideo
          };
          this.sfutest.send({ message: publish });
        } else {
          // 开启摄像头且首次发布的情况
          this.publishMyFeed();
        }
        this.sendChangeVideoOrAudioMessage();
      } else {
        if(!this.audioPermission){
          Toast("マイク権限が異常です。");
          return;
        }
        this.localStream.showLocalAudio = !this.localStream.showLocalAudio;
        this.$router.replace({
          path: this.$route.path,
          query: {...this.$route.query, mikeOpen: this.localStream.showLocalAudio}
        });
        if(this.localStream.showLocalAudio){
          this.sfutest.unmuteAudio();
        }else{
          this.sfutest.muteAudio();
        }
        this.sendChangeVideoOrAudioMessage();
      }
    },
    doHungUp() {
      if(this.yoteiTimeout){
        clearTimeout(this.yoteiTimeout);
      }
      if(this.yoteiInterval){
        clearInterval(this.yoteiInterval)
      }
      this.stopCanvas();
      if (this.sendStream) {
        this.sendStream.getTracks().forEach(track => track.stop());
        this.sendStream = null;
      }
      const sourceVideo = document.getElementById('soucevideo');
      if (sourceVideo && sourceVideo.srcObject) {
        const tracks = sourceVideo.srcObject.getTracks();
        tracks.forEach(track => track.stop());
        sourceVideo.srcObject = null;
      }

      if(!this.sfutest && this.$route.path =='/roomConversation'){
        history.back();
        return;
      }
      let userInfo = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      if(this.multiCallAdmin){
        // 如果是三方通话  并且是发起人 需要结束全部通话
        let to_users = [];
        this.feedStreams.forEach((item) => {
            to_users.push(item[0].user_id);
        });
        if(this.multiCallUser){
          to_users.push(this.multiCallUser);
        }
        let multiCallMsg = {send_type:"multiCall",method: "multiCall"
          ,type:"end",to_users:to_users,call_user:userInfo.login_account_id};
        doSend(JSON.stringify(multiCallMsg));
      }
      if(this.checkedShareScreen){
        this.closeShareScreen();
      }
      //挂断
      if (userInfo && userInfo.type === "4") {
        SaveRoomLog({
          doctor_id: userInfo.login_account_id,
          room_id: this.room_id,
          type: "leave",
        }).then((res) => {});
      }
      var hangup = { request: "leave" };
      if(this.sfutest){
        this.sfutest.send({ message: hangup });
      }
    },
    afterLeave(){
      this.sfutest.hangup();
      Janus.videoPageDestory();
    },
    changeFrame() {
      this.changeViewShow = !this.changeViewShow;
    },
    changeView(type){
      // 默认的是true
      this.changeViewShow = true;
      this.viewType = type;
      this.speaking_user = null;
      // 重新布置视频流
      this.setLocalVideo();
      this.setRemoteVideo();
      // 重新计算屏幕
      this.calcVideoSize();
    },
    clickScreen() {
      this.headerAndFooter = !this.headerAndFooter;

    },
    // 参加者リスト
    showUsers() {
      this.showUserList = !this.showUserList;
    },
  },
  watch: {
  },
  computed: {
  },
};
</script>

<style scoped>

.pageView{
  display:flex;
  flex-direction: column;
  height:100vh;
  width: 100%;
}
.footDiv{
  height:70px;
  display: flex;
  //justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  align-content:center;
  width:100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  display:grid;
  justify-items: center;
}
.footDiv .footDiv-item{
  height: 61px;
  width: auto;
  display: flex;
  margin :5px;
  flex-direction: column;
  text-align: center;
}
@media (hover: hover) and (pointer: fine) {
  .footDiv .footDiv-item:hover{
    background-color: #bdbbbb;
  }
  .footDiv .footDiv-item:hover * {
    cursor: pointer!important;
  }
}
.footDiv .footDiv-item img{
  width: 80px;
  height: calc(100% - 17px);
}
.footDiv .iconSpan{
  font-size: 15px;
  margin-top:2px;
}
.mainDiv{
  flex: 1;
  background-color:black;
  position: relative;
  overflow: auto;
  display: flex;
}
.multi-box{
  background: #222624;
  border-radius: 8px;
  box-sizing: border-box;
  position: absolute;
  top: 15px;
  right: 5px;
  z-index: 1;
  padding:10px;
  color: white;
  background-color: #4783cf;
}
.change-box{
  margin-top:15px;
  margin-left:15px;
  width: 176px;
  background: #222624;
  border-radius: 8px;
  box-sizing: border-box;
  position: fixed;
  z-index: 1;
}
.change-box .main-btn{
  height: 38px;
  background: url('../../assets/img/prototype/pt_icon-change.png') no-repeat 10px 11px;
  background-size: 16px auto;
  line-height: 38px;
}
.change-box .change-btn_speaker {
  height: auto;
  background: url('../../assets/img/prototype/pt_icon-speaker.png') no-repeat 10px 11px;
  background-size: 16px auto;
  line-height: 1.5;
  padding: 10px 26px 5px 32px;
}
.change-box .change-btn_grid {
  height: auto;
  background: url('../../assets/img/prototype/pt_icon-grid.png') no-repeat 10px 5px;
  background-size: 16px auto;
  line-height: 1.5;
  padding: 5px 26px 10px 32px;
}
.video-box{
  flex:1;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  overflow: auto;
  flex-direction: row;
  height:100%;
  align-content: center;
}
.nameSpan{
  position: absolute;
  left: 0;
  bottom: 0;
  color: #3B82C4;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bitSpan{
  position: absolute;
  right: 0;
  top: 0;
  color: #3B82C4;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bigNameSpan{
  font-size: 20px;
}
.no-video {
  background: #3B82C4;
  border-radius: 50%;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.no-video p {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
  color: #fff;
}
.sidebar-users-box {
  border-radius: 20px;
  position: fixed;
  color: #ffffff;
  top: 0;
  right: 0;
  width: 300px;
  height: 60vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
}
.sidebar-users-inner {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
}

.sidebar-close-btn {
  position: absolute;
  right: 10px;
  font-size: 20px;
}
.sidebar-users-item {
  display: flex;
  align-items: center;
  margin: 0;
  padding:10px;
  border-bottom: 1px solid #ffffff;
  font-size: 20px;
}
.sidebar-users-logo {
  width: 30px;
  height: 30px;
  background-color: grey;
  border-radius: 50%;
  color: white;
  text-align: center;
  line-height: 30px;
  margin-right: 10px;
  font-size: 20px;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none; /* for Safari and Chrome */
}

.hide-scrollbar {
  -ms-overflow-style: none; /* for IE 10+ */
  scrollbar-width: none; /* for Firefox */
}

.backgroundColorWhite{
  background-color: white;
}
.backgroundColorBlack{
  background-color: black;
}
.roomCoversation-audioText{
  bottom: 30px;
  width: 300px;
  height: 87px;
  background: #666464de;
  color: white;
  border-radius: 8px;
  padding: 8px 32px;
  position: absolute;
  left: 30px;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.roomCoversation-audioText p {
  font-weight: 600;
  font-size: 16px;
  line-height: 1.25;
}
video::-webkit-media-controls {
  display: none;
}
.status-indicators {
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  gap: 4px;
  z-index: 1;
}
.status-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
}
.status-icon img {
  width: 16px;
  height: 16px;
}
.status-icon.active {
  background-color: rgba(59, 130, 196, 0.8);
}
.status-icon.inactive {
  background-color: rgba(255, 59, 59, 0.8);
}
</style>